/**
 * FabAmhsInstances3D.tsx
 *
 * GPU-Instanced Floor Layer for all Fab Equipment and Stockers.
 * Renders the REAL 3D models (CleanroomWorkcell, Awp300, IndustrialVerticalLifter, Stocker3D, CircleStocker)
 * via high-performance GPU InstancedMultiMeshGroups.
 */

import React from 'react';
import type { EquipmentRenderDescriptor } from './equipmentSilhouettePorts';
import type { LayoutElement } from '../../types';
import { InstancedEquipment } from '../../3d/instancing/InstancedEquipment';
import { InstancedStocker } from '../../3d/instancing/InstancedStocker';

export type FabAmhsInstances3DProps = {
  descriptors: EquipmentRenderDescriptor[];
  /** Full-detail kits rendered elsewhere — omit from instancing to avoid z-fighting. */
  excludeIds?: ReadonlySet<string>;
  layoutMeta?: Record<string, Pick<LayoutElement, 'metadata' | 'customProperties'>>;
  onSelect?: (id: string) => void;
};

export const FabAmhsInstances3D: React.FC<FabAmhsInstances3DProps> = React.memo(
  ({ descriptors, excludeIds, layoutMeta, onSelect }) => {
    if (descriptors.length === 0) {
      return null;
    }

    return (
      <group name="FabAmhsInstances3D">
        <InstancedEquipment
          descriptors={descriptors}
          excludeIds={excludeIds}
          layoutMeta={layoutMeta}
          onSelect={onSelect}
        />
        <InstancedStocker
          descriptors={descriptors}
          excludeIds={excludeIds}
          layoutMeta={layoutMeta}
          onSelect={onSelect}
        />
      </group>
    );
  }
);

FabAmhsInstances3D.displayName = 'FabAmhsInstances3D';

/** Fixed instanced batch count for fab-scale regression checks. */
export const FAB_AMHS_INSTANCED_BATCHES = 14;

export default FabAmhsInstances3D;
